import { isEnumComponentVariableMutable, } from "../component-mutable/model/EnumComponentVariableMutable";
import { isComponentVariableMutable, } from "../component-mutable/model/ComponentVariableMutable";
import { isComponentSocketMutable, } from "../component-mutable/model/ComponentSocketMutable";
import { isEnumListComponentVariableMutable, } from "../component-mutable/model/EnumListComponentVariableMutable";
const createBaseComponentSettingUpdateRequest = (setting) => {
    return {
        display_name: setting.getDisplayName(),
        tags: setting.getTags(),
        type: setting.getType(),
        priority: setting.getPriority(),
    };
};
const createComponentVariableUpdateRequest = (setting) => {
    const baseRequest = createBaseComponentSettingUpdateRequest(setting);
    return Object.assign(Object.assign({}, baseRequest), { description: setting.getDescription(), source: setting.getSource(), type: setting.getType(), values: setting.getValues() });
};
const createEnumComponentVariableUpdateRequest = (setting) => {
    const baseRequest = createComponentVariableUpdateRequest(setting);
    return Object.assign(Object.assign({}, baseRequest), { allowed_values: setting.getAllowedValues() });
};
const createEnumListComponentVariableUpdateRequest = (setting) => {
    const baseRequest = createComponentVariableUpdateRequest(setting);
    return Object.assign(Object.assign({}, baseRequest), { allowed_values: setting.getAllowedValues() });
};
const createComponentSocketUpdateRequest = (setting) => {
    const baseRequest = createBaseComponentSettingUpdateRequest(setting);
    return Object.assign(Object.assign({}, baseRequest), { filter: setting.getFilter(), description: setting.getDescription(), type: "MULTI_SOCKET" });
};
export const createComponentSettingUpdateRequest = (mutable) => {
    if (isEnumComponentVariableMutable(mutable)) {
        return createEnumComponentVariableUpdateRequest(mutable);
    }
    if (isEnumListComponentVariableMutable(mutable)) {
        return createEnumListComponentVariableUpdateRequest(mutable);
    }
    if (isComponentVariableMutable(mutable)) {
        return createComponentVariableUpdateRequest(mutable);
    }
    if (isComponentSocketMutable(mutable)) {
        return createComponentSocketUpdateRequest(mutable);
    }
    return createBaseComponentSettingUpdateRequest(mutable);
};
